import React from "react";

export function Chip({ active, disabled, onToggle, children, testId }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={disabled}
      data-testid={testId}
      aria-pressed={!!active}
      className={`px-4 py-2 rounded-full border text-sm ${disabled && !active ? "opacity-40 cursor-not-allowed" : ""}`}
      style={{
        borderColor: active ? "hsl(var(--nvl-ink))" : "hsl(var(--nvl-border))",
        backgroundColor: active ? "hsl(var(--nvl-ink))" : "transparent",
        color: active ? "hsl(var(--nvl-bg))" : "hsl(var(--nvl-ink))",
        transition: "background-color 180ms, color 180ms, border-color 180ms",
      }}
    >
      {children}
    </button>
  );
}

export function ChipGroup({ options, value, onChange, multi = false, max, labelFor, testIdPrefix }) {
  const values = multi ? (value || []) : value;
  const isActive = (opt) => (multi ? values.includes(opt) : values === opt);

  const toggle = (opt) => {
    if (multi) {
      const set = new Set(values);
      if (set.has(opt)) set.delete(opt);
      else {
        if (max && values.length >= max) return;
        set.add(opt);
      }
      onChange(Array.from(set));
    } else {
      onChange(values === opt ? null : opt);
    }
  };

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => (
        <Chip
          key={opt}
          active={isActive(opt)}
          disabled={multi && max ? (!isActive(opt) && values.length >= max) : false}
          onToggle={() => toggle(opt)}
          testId={testIdPrefix ? `${testIdPrefix}-${opt}` : undefined}
        >
          {labelFor ? labelFor(opt) : opt}
        </Chip>
      ))}
    </div>
  );
}

export function FieldLabel({ children, required, recommended, optional }) {
  return (
    <label className="text-xs uppercase tracking-widest flex items-center gap-2" style={{ color: "hsl(var(--nvl-ink-soft))" }}>
      <span>{children}</span>
      {required ? <span style={{ color: "hsl(var(--nvl-accent))" }}>•</span> : null}
      {recommended ? <span className="text-[9px] opacity-60">rec</span> : null}
      {optional ? <span className="text-[9px] opacity-60">opt</span> : null}
    </label>
  );
}
